import React from 'react';
import { useRightClick } from './rightClickProvider';
import RMDropdown from 'components/dropdowns/RMDropdown';

interface Props {
  children: React.ReactNode;
}

const RightClickWrapper = (props: Props) => {
  const { children } = props;
  const { menuPosition, menuItems, closeMenu } = useRightClick();
  return (
    <>
      {children}
      {menuPosition && menuItems.length && (
        <div
          id="rightclickwrapper-main"
          style={{
            position: 'absolute',
            top: menuPosition.y,
            left: menuPosition.x,
          }}
        >
          <RMDropdown
            icon={null} // No icon for the right-click menu
            dropDownItems={menuItems}
            isDisabled={false}
            direction="ltr"
            onClick={closeMenu} // Close the menu when an item is clicked
            isAlwaysOpen
          />
        </div>
      )}
    </>
  );
};

export default RightClickWrapper;
